module.exports = __webpack_public_path__ + "static/img/3_Tom.53490a8e.jpg";